// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/bo-core/grids/RolesGrid/components/createUserModal/createRoleModalStyles.css
// module id = 775
// module chunks = 1